import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";

interface Emits {
  (e: "insert-emoji", emoji: string): void;
}
interface Props {
  emoji: string;
  size?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EmojiItem',
  props: {
    emoji: {},
    size: {}
  },
  emits: ["insert-emoji"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const insertEmoji = (emoji: string) => {
  emit("insert-emoji", emoji);
};

const sizeString = computed(() => `${props.size}px`);
const styleObj = computed(() => {
  if (!props.size) return {};
  return {
    fontSize: sizeString.value,
    height: sizeString.value,
    width: sizeString.value,
    lineHeight: sizeString.value,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "emoji-item",
    style: _normalizeStyle(styleObj.value),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (insertEmoji(_ctx.emoji)))
  }, _toDisplayString(_ctx.emoji), 5))
}
}

})